module.exports = "<div class=\"footer\"> <p> <span jhiTranslate=\"global.title\">Queuing System</span> <span>&copy;</span> <span>{{ getYear() }}</span> </p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/main/footer/page-footer.component.html
// module id = 344
// module chunks = 0